// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-NotesModal-module__actions";
var _2 = "webpack-concepts-Extraction-StudyList-NotesModal-module__addNote";
var _3 = "webpack-concepts-Extraction-StudyList-NotesModal-module__authorName";
var _4 = "webpack-concepts-Extraction-StudyList-NotesModal-module__details";
var _5 = "webpack-concepts-Extraction-StudyList-NotesModal-module__editButton";
var _6 = "webpack-concepts-Extraction-StudyList-NotesModal-module__note";
var _7 = "webpack-concepts-Extraction-StudyList-NotesModal-module__noteContent";
var _8 = "webpack-concepts-Extraction-StudyList-NotesModal-module__noteEditForm";
var _9 = "webpack-concepts-Extraction-StudyList-NotesModal-module__noteInput";
var _a = "webpack-concepts-Extraction-StudyList-NotesModal-module__timestamp";
export { _1 as "actions", _2 as "addNote", _3 as "authorName", _4 as "details", _5 as "editButton", _6 as "note", _7 as "noteContent", _8 as "noteEditForm", _9 as "noteInput", _a as "timestamp" }
